export default "__VITE_ASSET__DXxJ0axW__"